<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import '@/plugins/highcharts.js'
import { useCoreStore } from '../../stores/core'

export default {
  name: 'TravelsModesEmissionsBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    values: function () {
      let values = []
      let intensities = this.ghgi.emissions.travels.status.intensity
      for (let position of Object.keys(intensities)) {
        let allTransportations = {}
        let i = 0
        for (let transportations of Travel.transportations) {
          allTransportations[transportations] =
            '<nobr>' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].intensity
            )
          allTransportations[transportations] +=
            ' +/- ' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].uncertainty
            ) +
            '</nobr>'
          i += 1
        }
        allTransportations['position'] =
          '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allTransportations)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let transportation of Travel.transportations) {
        columns.push({
          field: transportation,
          label: this.$t(transportation),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let series = []
      for (let status of this.coreStore.travelPositionLabels) {
        let intensity = this.ghgi.emissions.travels.status.intensity[status]
        let intensities = intensity.map((obj) => obj.intensity / 1000)
        let uncertainties = intensity.map((obj) => {
          return [
            (obj.intensity - obj.uncertainty) / 1000,
            (obj.intensity + obj.uncertainty) / 1000
          ]
        })
        series.push(
          {
            name: this.$t(status),
            data: intensities
          },
          {
            name: this.$t('uncertainty'),
            type: 'errorbar',
            lineWidth: 2,
            data: uncertainties
          }
        )
      }
      return series
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: Travel.transportations.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e.short')
          }
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
          valueSuffix: ' ' + this.$t('t.co2e')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
